import { useEffect, useRef } from "react";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino.js";
import { useDispatch } from "react-redux";
import { setFavoriteGames } from "../../store/gamesSlice.js";

export default function useFillFavorites(countGames, setLoader = () => {}) {
  const dispatch = useDispatch();
  const favoriteGames = useAppSelector((state) => state.games.favoriteGames);
  const useFillFullRef = useRef(false);

  const favoriteGamesLength = favoriteGames.length;

  useEffect(() => {
    const isFillFull = useFillFullRef.current;
    if ((countGames && countGames <= favoriteGamesLength) || isFillFull) {
      setLoader(false);
      return;
    }
    setLoader(true);

    API_CASINO.list
      .favorites({ maxGames: countGames })
      .then((e) => {
        // получение всех избранных игр
        if (!countGames) useFillFullRef.current = true;

        const list = e.data.list;
        dispatch(setFavoriteGames(list));
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [favoriteGamesLength, countGames]);
}
